let id = 0;

const uniqueId = () => {
  id++;
  return id;
};

export default uniqueId;
